// @ts-strict-ignore
import isNil from 'lodash/isNil';
import { formatTimestampUtc } from '~/helpers/formatting';
import type { IValueRangeConfig } from './types';

export const formatPublishedAttributeValue = (value, dataType) => {
  if (isNil(value)) {
    return '';
  }

  switch (dataType) {
    case 'date':
      return formatTimestampUtc(value, 'MM/DD/YYYY');
    case 'timestamp':
      return formatTimestampUtc(value, 'MM/DD/YYYY hh:mm A');
    case 'boolean':
      return (value ? 'True' : 'False');
    default:
      return value;
  }
};

export const getNumberValidationError = (validValueMin, validValueMax) => {
  if (!isNil(validValueMin) && !isNil(validValueMax)) {
    return `Must be between a value of ${validValueMin}-${validValueMax}`;
  }

  if (!isNil(validValueMin)) {
    return `Must be greater than or equal to ${validValueMin}`;
  }

  if (!isNil(validValueMax)) {
    return `Must be less than or equal to ${validValueMax}`;
  }

  return '';
};

export const getDateValidationError = (validValueMin, validValueMax, dataType) => {
  const validValueMinFormatted = formatPublishedAttributeValue(validValueMin, dataType);
  const validValueMaxFormatted = formatPublishedAttributeValue(validValueMax, dataType);

  if (validValueMin && validValueMax) {
    return `Must be between ${validValueMinFormatted} and ${validValueMaxFormatted}`;
  }

  if (validValueMin) {
    return `Must be on or after ${validValueMinFormatted}`;
  }

  if (validValueMax) {
    return `Must be on or before ${validValueMaxFormatted}`;
  }

  return '';
};

// Helper to get range info (label and color) from value and value_range_config
export const getRangeInfoFromValue = (
  value: number | null,
  rangeConfig: IValueRangeConfig[],
): { label: string; color: string | undefined } => {
  if (value === null || !rangeConfig?.length) {
    return { label: 'Unknown', color: undefined };
  }

  for (const range of rangeConfig) {
    const min = range.minValue ?? -Infinity;
    const max = range.maxValue ?? Infinity;
    if (value >= min && value < max) {
      return { label: range.label, color: range.color };
    }
  }
  return { label: 'Unknown', color: undefined };
};
